module.exports = __webpack_public_path__ + "static/media/aquiraz-ce.655510c3.jpg";